import React, { useState } from 'react';
import { Label, FormGroup, Input, Row, Col, Button, CardTitle } from 'reactstrap';
import MultiDropCustomerAutoComplete from './MultiDropCustomerAutoComplete';
import LineItemsMultipleDrop from './LineItemsMultipleDrop';
//! Google Map AutoComplete
import GoogleMapAutoComplete, { isCoordinateFallbackLabel } from '../../../Helpers/GoogleMapAutoComplete';
import LocationMapPickerModal from '../../../Helpers/LocationMapPickerModal';
import '../../../Helpers/googleMapAutoComplete.css';
import '../../../../assets/react-mapbox-autocomplete/index.css';

const DropoffInfoMultiDrop = ({
  multiDropWaypointsArray,
  setMultiDropWaypointsArray,
  multiDropWaypointsErrors,
  setMultiDropWaypointsErrors,
  storeId,
  handleMultiDropWaypointSelect,
  vendorLat,
  vendorLong,
  pickupItems
}) => {
  const [activePinIndex, setActivePinIndex] = useState(-1);

  return (
    <>
      {multiDropWaypointsArray.map((waypoint, index) => {
        return (
          <React.Fragment key={waypoint.id || waypoint.waypointId || `multidrop-waypoint-${index}`}>
            <hr style={{ borderColor: '#344675', borderStyle: 'solid' }}></hr>
            <Row>
              <Col style={{ textAlign: 'left' }}>
                <Button
                  className="btn btn-info"
                  size="sm"
                  onClick={() => {
                    let updateArray = [];
                    let errorsUpdate = [];
                    for (let i = 0; i < index; i++) {
                      updateArray.push(multiDropWaypointsArray[i]);
                      errorsUpdate.push(multiDropWaypointsErrors[i]);
                    }
                    updateArray.push({
                      waypointFirstname: '',
                      waypointLastname: '',
                      waypointPhone: '',
                      waypointAddress1: null,
                      waypointAddress2: null,
                      waypointFullAddress: '',
                      waypointLat: '',
                      waypointLng: '',
                      waypointCity: '',
                      waypointState: '',
                      waypointCountry: '',
                      waypointZip: '',
                      waypointInfo: {},
                      waypointDropoffInstruction: '',
                      waypointBusinessName: '',
                      waypointCustomerSuggestions: [],
                      isWaypointAutoFilled: false,
                      dropItems: [{ quantity: 1, detail: '' }],
                      dropItemsError: [false]
                    });
                    errorsUpdate.push({
                      waypointFirstname: false,
                      waypointLastname: false,
                      waypointPhone: false,
                      waypointAddress: false
                    });
                    for (let i = index; i < multiDropWaypointsArray.length; i++) {
                      updateArray.push(multiDropWaypointsArray[i]);
                      errorsUpdate.push(multiDropWaypointsErrors[i]);
                    }
                    setMultiDropWaypointsArray(updateArray);
                    setMultiDropWaypointsErrors(errorsUpdate);
                  }}
                >
                  Add Drop Above{' '}
                  <span style={{ display: 'inline' }} role="img" aria-label="up arrow">
                    🔺
                  </span>
                </Button>
              </Col>

              {multiDropWaypointsArray.length > 1 && (
                <Col style={{ textAlign: 'right' }}>
                  <Button
                    className="btn btn-warning"
                    size="sm"
                    onClick={() => {
                      setMultiDropWaypointsArray(
                        multiDropWaypointsArray.filter((ar, i) => {
                          return i !== index;
                        })
                      );
                      setMultiDropWaypointsErrors(
                        multiDropWaypointsErrors.filter((ie, i) => {
                          return i !== index;
                        })
                      );
                    }}
                  >
                    Delete
                  </Button>
                </Col>
              )}
            </Row>
            <CardTitle tag="h4" style={{ padding: 5, paddingTop: 10, textAlign: 'left' }}>
              Dropoff ({index + 1}) Information
            </CardTitle>
            <Row form={true}>
              <Col style={{ textAlign: 'left' }}>
                <Label for="infiniteDropCustomerFirstName">First Name</Label>
                <FormGroup className={multiDropWaypointsErrors[index].waypointFirstname ? 'has-danger' : 'thisIsAPlaceholderClass'}>
                  <MultiDropCustomerAutoComplete
                    multiDropWaypointsArray={multiDropWaypointsArray}
                    setMultiDropWaypointsArray={setMultiDropWaypointsArray}
                    index={index}
                    storeId={storeId}
                  />
                  <div hidden={!multiDropWaypointsErrors[index].waypointFirstname}>
                    <p style={{ color: 'red', marginTop: '4px' }}>This is a required field</p>
                  </div>
                </FormGroup>
              </Col>
              <Col style={{ textAlign: 'left' }}>
                <Label for="customerLastName">Last Name</Label>
                <FormGroup className={multiDropWaypointsErrors[index].waypointLastname ? 'has-danger' : 'thisIsAPlaceholderClass'}>
                  <Input
                    required
                    type="text"
                    name="customerLastName"
                    id="customer-last-name"
                    placeholder="Doe"
                    onChange={e => {
                      setMultiDropWaypointsArray(
                        multiDropWaypointsArray.map((ar, i) => (i === index ? { ...multiDropWaypointsArray[index], waypointLastname: e.target.value } : ar))
                      );
                    }}
                    value={multiDropWaypointsArray[index].waypointLastname}
                  />
                  <div hidden={!multiDropWaypointsErrors[index].waypointLastname}>
                    <p style={{ color: 'red', marginTop: '4px' }}>This is a required field</p>
                  </div>
                </FormGroup>
              </Col>
              <Col style={{ textAlign: 'left' }}>
                <Label for="customerPhone">Phone Number</Label>
                <FormGroup className={multiDropWaypointsErrors[index].waypointPhone ? 'has-danger' : 'thisIsAPlaceholderClass'}>
                  <Input
                    required
                    type="text"
                    name="customerPhone"
                    id="customer-phone"
                    placeholder="555-555-5555"
                    onChange={e =>
                      setMultiDropWaypointsArray(multiDropWaypointsArray.map((ar, i) => (i === index ? { ...multiDropWaypointsArray[index], waypointPhone: e.target.value } : ar)))
                    }
                    value={multiDropWaypointsArray[index].waypointPhone}
                  />
                  <div hidden={!multiDropWaypointsErrors[index].waypointPhone}>
                    <p style={{ color: 'red', marginTop: '4px' }}>Please enter a valid phone number (10-13 digits)</p>
                  </div>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="order-multidrop">Business Name (optional)</Label>
                  <Input
                    type="text"
                    name="multidropBusinessName"
                    id="multidrop-business-name"
                    placeholder="Store Name"
                    value={multiDropWaypointsArray[index].waypointBusinessName}
                    onChange={e => {
                      setMultiDropWaypointsArray(
                        multiDropWaypointsArray.map((ar, i) => (i === index ? { ...multiDropWaypointsArray[index], waypointBusinessName: e.target.value } : ar))
                      );
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                    <Label style={{ marginBottom: 0 }}>Delivery Address</Label>
                    <Button color="info" outline size="sm" onClick={() => setActivePinIndex(index)}>
                      Drop Pin
                    </Button>
                  </div>
                  {waypoint.isWaypointAutoFilled ? (
                    <Input
                      value={multiDropWaypointsArray[index].waypointFullAddress}
                      onChange={e =>
                        setMultiDropWaypointsArray(
                          multiDropWaypointsArray.map((ar, i) => (i === index ? { ...multiDropWaypointsArray[index], waypointFullAddress: e.target.value } : ar))
                        )
                      }
                    />
                  ) : (
                    // <MapboxAutocomplete
                    //   id="mapbox-autocomplete2"
                    //   inputClass="form-control mb-2"
                    //   publicKey={MAPBOX_TOKEN}
                    //   index={index}
                    //   onSuggestionSelect={handleMultiDropWaypointSelect}
                    //   country="us"
                    //   resetSearch={false}
                    //   // readOnly={isWaypointStore}
                    //   defaultValue={null}
                    //   value={multiDropWaypointsArray[index].waypointFullAddress}
                    //   query={multiDropWaypointsArray[index].waypointFullAddress}
                    //   placeholder="Street Address"
                    //   proximityLat={vendorLat}
                    //   proximityLng={vendorLong}
                    // />
                    <GoogleMapAutoComplete
                      inputClass="form-control mb-2"
                      index={index}
                      onSuggestionSelect={(...args) => {
                        setMultiDropWaypointsArray(
                          multiDropWaypointsArray.map((candidate, candidateIndex) =>
                            candidateIndex === index ? { ...candidate, isPinnedLocation: false } : candidate
                          )
                        );
                        handleMultiDropWaypointSelect(...args);
                      }}
                      country="us"
                      resetSearch={false}
                      // readOnly={isWaypointStore}
                      defaultValue={null}
                      value={multiDropWaypointsArray[index].waypointFullAddress}
                      query={multiDropWaypointsArray[index].waypointFullAddress}
                      placeholder="Street Address"
                      proximityLat={vendorLat}
                      proximityLng={vendorLong}
                    />
                  )}
                  {/* <div hidden={errorMessageDistance.errorCode !== 1}>
                    <p style={{ color: 'red', marginTop: '4px' }}>{errorMessageDistance.errorMessage}</p>
                  </div> */}
                  <div hidden={!multiDropWaypointsErrors[index].waypointAddress}>
                    <p style={{ color: 'red', marginTop: '4px' }}>Please choose an address from the dropdown menu</p>
                  </div>
                  {waypoint.isPinnedLocation ? (
                    <p style={{ color: isCoordinateFallbackLabel(waypoint.waypointFullAddress) ? '#f7941d' : '#6c757d', marginTop: '4px' }}>
                      Pinned location selected. Reopen Drop Pin to adjust it.
                    </p>
                  ) : null}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="order-dropoff">Dropoff Instructions (optional)</Label>
                  <Input
                    type="text"
                    name="waypointDropoff"
                    id="waypoint-dropoff-instructions"
                    placeholder="Gate Code, Apt. #, etc."
                    value={multiDropWaypointsArray[index].waypointDropoffInstruction}
                    onChange={e => {
                      if (e.target.value.length < 510) {
                        return setMultiDropWaypointsArray(
                          multiDropWaypointsArray.map((ar, i) => (i === index ? { ...multiDropWaypointsArray[index], waypointDropoffInstruction: e.target.value } : ar))
                        );
                      } else {
                        return;
                      }
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>

            <LineItemsMultipleDrop
              title="Drop off Item(s)"
              multiDropWaypointsArray={multiDropWaypointsArray}
              setMultiDropWaypointsArray={setMultiDropWaypointsArray}
              index={index}
              pickList={pickupItems}
            />
            <Row>
              <Col style={{ textAlign: 'left' }}>
                <Button
                  className="btn btn-info"
                  size="sm"
                  onClick={() => {
                    let updateArray = [];
                    let errorsUpdate = [];
                    for (let i = 0; i < index + 1; i++) {
                      updateArray.push(multiDropWaypointsArray[i]);
                      errorsUpdate.push(multiDropWaypointsErrors[i]);
                    }

                    updateArray.push({
                      waypointFirstname: '',
                      waypointLastname: '',
                      waypointPhone: '',
                      waypointAddress1: null,
                      waypointAddress2: null,
                      waypointFullAddress: '',
                      waypointLat: '',
                      waypointLng: '',
                      waypointCity: '',
                      waypointState: '',
                      waypointCountry: '',
                      waypointZip: '',
                      waypointInfo: {},
                      waypointDropoffInstruction: '',
                      waypointCustomerSuggestions: [],
                      isWaypointAutoFilled: false,
                      dropItems: [{ quantity: 1, detail: '' }],
                      dropItemsError: [false]
                    });
                    errorsUpdate.push({
                      waypointFirstname: false,
                      waypointLastname: false,
                      waypointPhone: false,
                      waypointAddress: false
                    });
                    for (let i = index + 1; i < multiDropWaypointsArray.length; i++) {
                      updateArray.push(multiDropWaypointsArray[i]);
                      errorsUpdate.push(multiDropWaypointsErrors[i]);
                    }
                    setMultiDropWaypointsArray(updateArray);
                    setMultiDropWaypointsErrors(errorsUpdate);
                  }}
                >
                  Add Drop Below{' '}
                  <span style={{ display: 'inline' }} role="img" aria-label="down arrow">
                    🔻
                  </span>
                </Button>
              </Col>
            </Row>
          </React.Fragment>
        );
      })}
      <LocationMapPickerModal
        isOpen={activePinIndex >= 0}
        toggle={() => setActivePinIndex(-1)}
        title="Select Dropoff Location"
        initialLocation={activePinIndex >= 0 && multiDropWaypointsArray[activePinIndex] && typeof multiDropWaypointsArray[activePinIndex].waypointLat === 'number' && typeof multiDropWaypointsArray[activePinIndex].waypointLng === 'number'
          ? {
              lat: multiDropWaypointsArray[activePinIndex].waypointLat,
              lng: multiDropWaypointsArray[activePinIndex].waypointLng,
              formattedAddress: multiDropWaypointsArray[activePinIndex].waypointFullAddress || ''
            }
          : null}
        onConfirm={location => {
          if (activePinIndex < 0) {
            return;
          }

          setMultiDropWaypointsArray(
            multiDropWaypointsArray.map((candidate, candidateIndex) => {
              if (candidateIndex !== activePinIndex) {
                return candidate;
              }

              return {
                ...candidate,
                waypointFullAddress: location.formattedAddress || location.address1 || '',
                waypointAddress1: location.address1 || location.formattedAddress || '',
                waypointAddress2: location.address2 || '',
                waypointCity: location.city || '',
                waypointState: location.state || '',
                waypointZip: location.zip || '',
                waypointCountry: location.countryCode || location.country || '',
                waypointLat: location.lat,
                waypointLng: location.lng,
                isPinnedLocation: true,
                isWaypointAutoFilled: false,
              };
            })
          );
        }}
      />
    </>
  );
};

export default DropoffInfoMultiDrop;
